import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { $liveqBooking } from '@store';
import mapIcon from '../../assets/images/map-pin.png';
import styles from './index.module.scss';
export const InfoStep = ({ question }) => {
    var _a;
    const getContent = (id) => {
        return $liveqBooking.content.find((item) => { var _a; return ((_a = item.parents.at(-1)) === null || _a === void 0 ? void 0 : _a.id) === id; });
    };
    const content = getContent(question.id);
    return (_jsx("div", { children: _jsxs("div", Object.assign({ className: styles.wrapper }, { children: [_jsx("div", Object.assign({ className: styles.wrapperTitle }, { children: content === null || content === void 0 ? void 0 : content.title })), _jsx("div", Object.assign({ className: styles.wrapperText }, { children: content === null || content === void 0 ? void 0 : content.description })), ((_a = content === null || content === void 0 ? void 0 : content.tags) === null || _a === void 0 ? void 0 : _a.some((el) => el === 'picture:step-2')) ? _jsx("img", { src: mapIcon, className: styles.wrapperImg, alt: "info" }) : null] })) }));
};
